/**
 * カードブランド
 */
export default [
  require('./amex').default,
  require('./diners').default,
  require('./discover').default,
  require('./jcb').default,
  require('./master').default,
  require('./visa').default
]
